export default defineNuxtRouteMiddleware((to, from) => {
  if (!to.matched.length) {
    const error = new Error('Page not found')
    error.statusCode = 404
    throw error
  }
})
